<mat-card class="cardWithShadow theme-card">
    <mat-card-content class="b-t-1">
     <table class="est-table">
        @for(obj of getKyes(companyData); track $index){
          <tr><td class="text-capitalize">{{getLabel(obj)}}</td><td>{{companyData[obj]}}</td></tr>
        }
     </table>
    </mat-card-content>
  </mat-card>